var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mb-5 justify-content-end" },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-content-end  mt-2" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter_2 mx-3",
                  attrs: { variant: "primary" },
                  on: { click: _vm.trigOnImportCSV },
                },
                [
                  _c("i", { staticClass: "fa-light fa-plus " }),
                  _vm._v(" "),
                  _c("span", { staticClass: "fab-label" }, [
                    _vm._v(_vm._s(_vm.$t("toolbox.import_testcase"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                ref: "fileInput",
                staticClass: "d-none",
                attrs: { type: "file", accept: ".csv" },
                on: { change: _vm.onImportCSV },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-2", attrs: { cols: "4", lg: "2", xl: "2" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter",
                  on: {
                    click: function ($event) {
                      _vm.displayFilter = !_vm.displayFilter
                    },
                  },
                },
                [
                  _vm.displayFilter
                    ? _c("i", { staticClass: "fa-light fa-minus" })
                    : _c("i", { staticClass: "fa-light fa-plus" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("filter.fltr")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-2", attrs: { cols: "4", lg: "2", xl: "2" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter",
                  on: {
                    click: function ($event) {
                      return _vm.refreshInbox()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-rotate-right" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.rfrsh")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mx-auto" }),
      _vm._v(" "),
      _vm.displayFilter
        ? _c(
            "b-row",
            {
              staticClass: "min-w-100 justify-content-start align-items-center",
            },
            [
              _c(
                "b-col",
                { staticClass: "filter-item", attrs: { sm: "6", lg: "3" } },
                [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("toolbox.filtre_status")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.StatusFilter,
                            expression: "StatusFilter",
                          },
                        ],
                        staticClass: "filter-item-content w-100",
                        staticStyle: { padding: "0.5rem" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.StatusFilter = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v("----------"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "2" } }, [
                          _vm._v(_vm._s(_vm.$t("toolbox.filtre_status_ok"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0" } }, [
                          _vm._v(_vm._s(_vm.$t("toolbox.filtre_status_ko"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "3" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("toolbox.filtre_status_missing_conf"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "4" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("toolbox.filtre_status_pending"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "5" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("toolbox.filtre_status_not_tested"))
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "filter-item", attrs: { sm: "6", lg: "3" } },
                [
                  _c("label", { staticClass: "filter-item-title" }, [
                    _vm._v(_vm._s(_vm.$t("toolbox.filtre_case_summary"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "filter-item-content" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.CaseSummary,
                          expression: "CaseSummary",
                          modifiers: { trim: true },
                        },
                      ],
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.CaseSummary,
                      },
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("toolbox.filtre_case_summary"),
                      },
                      domProps: { value: _vm.CaseSummary },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.CaseSummary = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-row-reverse mt-3",
                  attrs: { lg: "3", cols: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.applyFilter()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.srch")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-3",
                      attrs: { size: "sm", disabled: !_vm.hasInputFilter },
                      on: { click: _vm.clearFilterFields },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("filter.clr_fltr_field")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayFilter
        ? _c("b-row", {
            staticClass: "min-w-100 justify-content-end mb-5 mr-1",
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayFilter ? _c("hr", { staticClass: "mx-auto mb-4" }) : _vm._e(),
      _vm._v(" "),
      _vm.activateSpinner
        ? _c("spinner")
        : _vm.RequestList.length > 0
        ? _c(
            "div",
            { staticStyle: { overflow: "auto" } },
            [
              _c("b-table", {
                staticClass: "table table-striped",
                staticStyle: { "margin-bottom": "0" },
                attrs: {
                  hover: "",
                  fields: _vm.fields,
                  items: _vm.RequestList,
                  selectable: _vm.RequestList.length > 0,
                  "per-page": _vm.paginationObject.maxResults,
                  "current-page": _vm.pageCounter,
                  "empty-text": _vm.$t("common.security.no_result"),
                },
                on: { "row-clicked": _vm.seeRequestTBDetails },
                scopedSlots: _vm._u([
                  {
                    key: "cell(response_request)",
                    fn: function (data) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " + _vm._s(data.item.ids_dataset.length) + " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(case_summary)",
                    fn: function (data) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "toolbox.req_summary_case." +
                                    data.item.case_summary
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(description_case)",
                    fn: function (data) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "toolbox.req_description_case." +
                                    data.item.description_case
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(status)",
                    fn: function (data) {
                      return [
                        data.value === "2"
                          ? _c("div", [
                              _c("i", {
                                staticClass: "fas fa-check",
                                staticStyle: {
                                  color: "white",
                                  "background-color": "green",
                                  "border-radius": "50%",
                                  padding: "5px",
                                  width: "20px",
                                  height: "20px",
                                  display: "inline-flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                },
                                attrs: { title: "OK" },
                              }),
                            ])
                          : data.value === "0"
                          ? _c("div", [
                              _c("i", {
                                staticClass: "fas fa-multiply",
                                staticStyle: {
                                  color: "white",
                                  "background-color": "red",
                                  "border-radius": "50%",
                                  padding: "5px",
                                  width: "20px",
                                  height: "20px",
                                  display: "inline-flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                },
                                attrs: { title: "KO" },
                              }),
                            ])
                          : data.value === "1"
                          ? _c("div", [
                              _c("i", {
                                staticClass: "fas fa-hourglass-half",
                                staticStyle: {
                                  color: "white",
                                  "background-color": "orange",
                                  "border-radius": "50%",
                                  padding: "5px",
                                  width: "20px",
                                  height: "20px",
                                  display: "inline-flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                },
                                attrs: { title: "RUN" },
                              }),
                            ])
                          : data.value === "3"
                          ? _c("div", [
                              _c("i", {
                                staticClass: "fas fa-file-alt",
                                staticStyle: {
                                  color: "gray",
                                  "font-size": "20px",
                                },
                                attrs: { title: "Missing configuration" },
                              }),
                            ])
                          : data.value === "4"
                          ? _c("div", [
                              _c("i", {
                                staticClass: "fas fa-hourglass-half",
                                staticStyle: {
                                  color: "gray",
                                  "font-size": "20px",
                                },
                                attrs: { title: "Pending" },
                              }),
                            ])
                          : data.value === "5"
                          ? _c("div", [
                              _c("i", {
                                staticClass: "fas fa-minus",
                                staticStyle: {
                                  color: "white",
                                  "background-color": "gray",
                                  "border-radius": "50%",
                                  padding: "5px",
                                  width: "20px",
                                  height: "20px",
                                  display: "inline-flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                },
                                attrs: { title: "Never tested" },
                              }),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          )
        : _c("div", { staticClass: "d-flex justify-content-center" }, [
            _c("span", { staticClass: "noResult" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("common.no_result")) + "\n    "
              ),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("cm-pagination", {
                attrs: {
                  maxResultsByPage: _vm.paginationObject.maxResults,
                  firstIndex: _vm.paginationObject.firstIndex,
                  nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                  refreshEvent: _vm.paginationObject.refresh,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }